import Card from './Card.vue';
import { CUSTOMER_FEEDBACK } from './constants';

export const CustomerFeedback = {
	name: CUSTOMER_FEEDBACK,
	components: {
		Card,
	},
};
